var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",staticStyle:{"height":"100%"}},[[_c('div',{staticClass:"choice-list"},_vm._l((_vm.subSubjectList),function(item){return _c('van-cell',{key:item.id.value,attrs:{"title":item.childBillingAccountName,"is-link":""},on:{"click":function($event){return _vm.choiceProject(item)}}})}),1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }